function DropdownSelected (value) {
    return value !== "";
}

export default DropdownSelected
